<script setup lang="ts">
import type { StopChip as SC } from '~/types'

const props = defineProps({
  title: {
    type: String,
    default: '',
  },
  message: {
    type: String,
    default: '',
  },
  line: {
    type: String,
  },
  color: {
    type: String,
  },
})

const stop = {
  name: props.line,
  colour: props.color,
} as SC
</script>
<template>
  <div
    class="w-full flex justify-between items-center flex-col p-4 md:flex-row border border-solid border-1 border-vmcv-danger bg-vmcv-gray"
  >
    <div class="p-2 md:p-10 shrink-0">
      <div>
        <img class="h-5 w-5" src="/svg/vehicle.svg" alt="" />
      </div>
    </div>
    <div class="grow text-vmcv-gray-darkest py-4">
      <h4>{{ title }}</h4>
      <p v-html="message"></p>
    </div>
  </div>
</template>
